module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[59]58.c2e3ccb.woff2";